import React from 'react';

import { Text } from '../../../storyblocks-design-system/components/atoms/Text/Text';
import ProgressiveImage from '../../elements/ProgressiveImage/ProgressiveImage';
import type { Testimonial } from './Testimonial.type';
import { TestimonialAuthor } from './TestimonialAuthor';

export const HeroTestimonial = ({
  testimonial,
}: {
  testimonial: Testimonial;
}) => (
  <article
    className="flex flex-col md:flex-row items-start gap-4 md:gap-8"
    aria-labelledby={`hero-testimonial-author-${testimonial.name
      .replace(/\s+/g, '-')
      .toLowerCase()}`}
  >
    <div
      className="w-38 md:w-36 lg:w-70 h-38 md:h-36 lg:h-70 rounded-xl overflow-hidden flex-shrink-0 relative"
      aria-hidden="true"
    >
      <ProgressiveImage
        className="w-full h-full object-cover"
        src={testimonial.image}
        alt={testimonial.imageAlt || `Photo of ${testimonial.name}`}
        shouldLazyLoad={testimonial.lazyLoadImage}
        width="full"
        height="full"
      />
    </div>
    <div
      className="flex-1 bg-white border-2 rounded-xl p-6 md:p-8 lg:p-12 space-y-12"
      role="group"
      aria-label="Featured customer testimonial"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="48"
        viewBox="0 0 64 48"
        fill="none"
        className="w-10 h-10 text-blue-700"
        aria-hidden="true"
        role="presentation"
      >
        <path
          d="M26.1818 0L18.3636 15.0909C17.6364 16.5455 16.1818 18.1818 14.5455 19.0909C12 20.3636 10.1818 20.9091 10.5455 22.3636C10.9091 23.8182 12.1818 23.6364 14.7273 22.7273C16.9091 22 18.7273 21.8182 20.5455 21.8182H26.1818V48H0V24.3636C0 17.6364 2.72727 14.3636 10.5455 0H26.1818ZM64 0L56.1818 15.0909C55.4545 16.5455 54 18.1818 52.3636 19.0909C49.8182 20.3636 48 20.9091 48.3636 22.3636C48.7273 23.8182 50 23.6364 52.5455 22.7273C54.7273 22 56.5455 21.8182 58.3636 21.8182H64V48H37.8182V24.3636C37.8182 17.6364 40.5455 14.3636 48.3636 0H64Z"
          fill="#0066CC"
        />
      </svg>
      <div
        className="flex flex-col gap-4 md:gap-6"
        role="group"
        aria-label="Testimonial content"
      >
        <Text
          asChild
          fontFamily="polysans"
          fontSize="2xl"
          className="text-gray-900"
        >
          <blockquote
            dangerouslySetInnerHTML={{ __html: testimonial.quote }}
            cite={testimonial.name}
            aria-label="Featured customer testimonial quote"
          />
        </Text>
        <TestimonialAuthor
          name={testimonial.name}
          title={testimonial.title}
          isHero
        />
      </div>
    </div>
  </article>
);
